import {
  Box,
  Button,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerOverlay,
  Flex,
  HStack,
  IconButton,
  Spacer,
  useDisclosure,
  VStack,
} from "@chakra-ui/react";

import { Link } from "react-scroll";
import { useRef } from "react";

import { DownloadIcon, HamburgerIcon } from "@chakra-ui/icons";

function resume() {
  window.open(
    "https://drive.google.com/file/d/11AT2gijQIE6jCS1Z-Q5lH8TIUnpmG1N3/view?usp=share_link",
    "_blank"
  );
}

function Navbar() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = useRef();

  return (
    <div id="nav-menu">
      <Drawer
       size={["xs", "xs"]}
        isOpen={isOpen}
        placement="top"
        onClose={onClose}
        finalFocusRef={btnRef}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerBody>
            <VStack align="left" spacing={5}>
              <Link to="home" className="nav-link home" smooth={true} duration={900} spy={true}>
                HOME
              </Link>
              <Link to="about" className="nav-link about" smooth={true} duration={900} spy={true}>
                ABOUT
              </Link>
              <Link to="skills" className="nav-link skills" smooth={true} duration={900} spy={true}>
                SKILLS
              </Link>
              <Link to="projects" className="nav-link projects" smooth={true} duration={900} spy={true}>
                PROJECTS
              </Link>
              <Link to="contact" className="nav-link contact" smooth={true} duration={900} spy={true}>
                CONTACT
              </Link>
              {/* <a href={"Charchit_Khandelwal_Resume.pdf"} download  id="resume-link-1">
                <Button
                className="nav-link resume"
                  mt={5}
                  mb={5}
                  colorScheme="red"
                  fontWeight="bold"
                  letterSpacing="3px"
                  id="resume-button-1"
                  onClick={() =>
                    window.open(
                      "https://drive.google.com/file/d/11AT2gijQIE6jCS1Z-Q5lH8TIUnpmG1N3/view?usp=share_link"
                    )
                  }                  
                >
                  RESUME
                  <DownloadIcon ml="9px" />
                </Button>
              </a> */}
               <Button id="resume-button-1" onClick={resume} backgroundColor="#0A536F"
                className="nav-link resume"
                fontWeight="bold"
                letterSpacing="3px"
                color={"white"}>
              <a
                id="resume-link-1"
                href="Charchit_Khandelwal_Resume.pdf"
                download="Charchit_Khandelwal_Resume"
                target="_blank"
               
              >
                RESUME
              </a>
            </Button>
            </VStack>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
      <HStack
        display={["none", "none", "none", "flex"]}
        zIndex={200}
        position="fixed"
        // top="0"
        width="100%"
        bgColor="#272727"
        borderBottom="1px"
        h="61px"
      >
        {/* <Social /> */}
        <Spacer />

        <Flex px="22px" align="center">
          <HStack
            w="60vw"
            display="flex"
            justifyContent="space-evenly"
            fontWeight="semibold"
            letterSpacing="3px"
          >
            <Box cursor="pointer">
              <Link
                cursor="pointer"
                to="home"
                smooth={true}
                duration={900}
                spy={true}
                offset={-100}
                className="nav-link home"
              >
                HOME
              </Link>
            </Box>

            <Box cursor="pointer">
              <Link
                to="about"
                smooth={true}
                duration={900}
                spy={true}
                offset={-40}
                className="nav-link about"
              >
                ABOUT
              </Link>
            </Box>
            <Box cursor="pointer">
              <Link
                to="skills"
                smooth={true}
                duration={900}
                spy={true}
                offset={-40}
                className="nav-link skills"
              >
                SKILLS
              </Link>
            </Box>
            <Box cursor="pointer">
              <Link
                to="projects"
                smooth={true}
                duration={900}
                spy={true}
                offset={-30}
                className="nav-link projects" 
              >
                PROJECTS
              </Link>
            </Box>
            <Box cursor="pointer">
              <Link
                to="contact"
                smooth={true}
                duration={900}
                spy={true}
                offset={-30}
                className="nav-link contact"
              >
                CONTACT
              </Link>
            </Box>
            {/* <a href={"Charchit_Khandelwal_Resume.pdf"} download  id="resume-link-1">
              <Button
               className="nav-link resume"
               id="resume-button-1"
              _hover={{backgroundColor:'white',color:'#0A536F'}}
                onClick={() =>
                  window.open(
                    "https://drive.google.com/file/d/11AT2gijQIE6jCS1Z-Q5lH8TIUnpmG1N3/view?usp=share_link"
                  )
                }
                mt={5}
                mb={5}
                backgroundColor="#0A536F"
                fontWeight="bold"
                letterSpacing="3px"
                color={"white"}
              >
                RESUME
                <DownloadIcon ml="9px" />
              </Button>
            </a> */}
               <Button id="resume-button-1" onClick={resume} backgroundColor="#0A536F"
                className="nav-link resume"
                fontWeight="bold"
                letterSpacing="3px"
                color={"white"}>
              <a
                id="resume-link-1"
                href="Charchit_Khandelwal_Resume.pdf"
                download="Charchit_Khandelwal_Resume"
                target="_blank"
               
              >
                RESUME
              </a>
            </Button>
          </HStack>
        </Flex>
      </HStack>
      <HStack
      width="100%"
        position="fixed"
        top={0}
        px="11px"
        py="5px"
        zIndex={200}
        borderBottom="1px"
        borderColor="gray.100"
        bgColor="#272727"
        display={["flex", "flex", "flex", "none"]}
      >
        <IconButton
          aria-label="Open Menu"
          mr={2}
          size="md"
          onClick={onOpen}
          isRound={true}
          bgColor='#03212E'
          icon={<HamburgerIcon color={'white'} bgColor='#272727' />}
        />
        <Spacer />
      </HStack>
    </div>
  );
}

export default Navbar;
